/**
 * Helpers compartidos del flujo de pago con Redsys/Cyberpac.
 */

/**
 * Crea un formulario POST con los campos firmados devueltos por el backend y lo envía
 * al TPV (redirección completa de la página).
 */
export const submitFormularioRedsys = ({ url, fields }) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
};

/**
 * Traduce un error de axios del inicio de pago de un recibo a `{ status, mensaje }`.
 * Si el backend devuelve `{ error }` en el cuerpo, se usa ese texto.
 */
export const extraerErrorMensaje = (err, { porDefecto = 'No se pudo iniciar el pago.' } = {}) => {
  const status = err?.response?.status;
  const body = err?.response?.data;
  // El texto de Zod ('Validation failed') no sirve al alumno: solo ocurre si la
  // petición está mal formada (p.ej. sesión corrupta), así que pedimos recargar.
  if (body?.error === 'Validation failed') {
    return {
      status,
      mensaje: 'La solicitud no es válida. Recarga la página e inténtalo de nuevo.',
    };
  }
  if (body?.error) return { status, mensaje: body.error };
  if (status === 404) return { status, mensaje: 'Recibo no encontrado.' };
  if (status === 409) return { status, mensaje: 'Este pago ya no está pendiente.' };
  if (status === 403) return { status, mensaje: 'No tienes acceso a este recibo.' };
  return { status, mensaje: porDefecto };
};
